import { Grid, Box, Typography, Avatar } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import moment from "moment";
import { isMobile } from "react-device-detect";
import qs from "qs";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import Configs from "../../constants/Configs";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
import {
  getData,
  storeData,
  clearData,
  getAllStorage,
} from "../../utils/GlobalHelper";
import HeaderPage from "../../components/HeaderPage/Index";
import Loading from "../../components/loading/loading";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import { Wrapper } from "../../components/NDID2";
import GlobalApi from "../../utils/GlobalApi";
import DIPCHIP_ICON from "../../assets/image/DIPCHIP_icon.png";

import DAOL_ICON from "../../assets/image/daol_icon.png";
const statusArr = {
  LOADING: ["LOADING", "LOADING"],
  ACCEPTED: ["ยืนยันตัวตนสำเร็จ", "ยืนยันตัวตนสำเร็จ"],
};
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
const DipchipWaiting = (props) => {
  const translations = getData("Translations");
  const header = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const [lang, setLang] = useState(getData("lang"));
  const idc = getData("idc");
  const ic = getData("current_ic");
  //   const [countDown, setCountDown] = useState(getData("countDown"));
  const [dipchipData, setDipchipData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
  );
  const [modalErrorMssDes, setModalErrorMssDes] = useState("");
  const [isMaxQuota, setisMaxQuota] = useState(false);
  // let isMaxQuota = false;
  const [nextStep, setNextStep] = useState(false);
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const [isModal, setIsModal] = useState(false);
  const [valueModal, setValueModal] = useState({
    isMax: false,
    imgError: true,
    imgSuccess: false,
    title: "ท่านสามารถเปลี่ยนธนาคารได้ 3 ครั้ง",
    massage: "กรุณาตรวจสอบที่แอปพลิเคชันของธนาคารก่อน ยืนยันการเปลี่ยนธนาคาร",
    btnPrimary: "ดำเนินการต่อที่",
    btnSecondary: "ยืนยันการเปลี่ยนธนาคาร",
  });
  const handleNext = async () => {
    // หน้าถัดจากยืนยันตัวตน
    checkDipchip();
  };
  const handleBack = async () => {
    saveComeback("EKYC");
  };
  const saveComeback = async (type) => {
    storeData("stamp_page", type);
    var last_stamp = JSON.stringify(await getAllStorage(type));
    const saveData = [
      {
        name: "comeback",
        url: `${Configs.baseAPIURL03}/form/comeback/manp`,
        postData: {
          head_token: head_token,
          last_stamp: last_stamp,
          stamp_page: type,
        },
      },
    ];
    setIsLoading(true);
    try {
      await GlobalApi.post(
        saveData[0].url,
        qs.stringify(saveData[0].postData),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        },
      )
        .then((res) => {
          setIsLoading(false);
          if (res?.data?.Data?.[0]?.[0]?.IsSuccess !== 1) {
            let mss =
              res.data.Data[0].MsgDesc !== ""
                ? res.data.Data[0].MsgDesc
                : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
            let title = "เกิดข้อผิดพลาด";
            setIsLoading(false);
            setIsModalError(true);
            setModalErrorTitle(title);
            setModalErrorDes(mss);
          } else {
            type === "EKYC"
              ? props.history.push("/ekyc")
              : type === "CONFIRM"
                ? props.history.push("/products_consent")
                : "";
          }
        })
        .catch((er) => {
          setIsLoading(false);
          let title = "เกิดข้อผิดพลาด";
          let mss =
            "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
            getData("api_error")?.message +
            ")";
          setIsModalError(true);
          setModalErrorTitle(title);
          setModalErrorDes(mss);
        });
    } catch (error) {
      setIsLoading(false);
      setIsModalError(true);
    }
  };
  const checkDipchip = async () => {
    setIsLoading(true);

    const saveData = [
      {
        name: "dipchip_status",
        url: `${Configs.baseAPIURL03}/form/dipchip_status/selbyhead`,
        postData: {
          head_token: head_token,
          id_card: idc?.idCard,
          ae_code: ic?.AECode,
        },
      },
    ];
    try {
      await GlobalApi.post(saveData[0].url, saveData[0].postData, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res?.data?.Data?.[0]?.IsSuccess !== 1) {
            console.log(ic);
            const ICTel = ic.ICTel ? `กด 0 ต่อ ${ic.ICTel}` : "";
            const icText = `${ic.AECode} - ${ic.ICName} <br>เบอร์โทร : 0 2351 1800 ${ICTel}`;
            let mssDes = `
            <p>เพื่อเสียบบัตรประชาชน (Dip Chip)</p>
             <p style="background-color: rgb(247, 248, 251);padding: 10px;"> ${icText}
             <br>
            <br>เพื่อดำเนินการยืนยันตัวตนด้วยการ Dip Chip 
            </p>
            <p>
            หากท่านต้องการเปลี่ยนช่องทางการยืนยันตัวตน <br>ท่านสามารถกดย้อนกลับ เพื่อเลือกช่องทางการยืนยันตัวตน อื่นๆ ได้
            <br>หรือติดต่อ DAOL Contact Center 0 2351 1800 เพื่อสอบถามข้อมูลเพิ่มเติม
            </p>`;
            let title = "กรุณาติดต่อเจ้าหน้าที่แนะนำการลงทุน";
            setIsLoading(false);
            setIsModalError(true);
            setModalErrorTitle(title);
            setModalErrorDes("");
            setModalErrorMssDes(mssDes);
          } else {
            await saveDipchip(res?.data?.Data?.[0].Data?.[0]);
          }
        })
        .catch((er) => {
          console.log(er);
          setIsLoading(false);
          let title = "เกิดข้อผิดพลาด";
          let mss =
            "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
            getData("api_error")?.message +
            ")";
          setIsModalError(true);
          setModalErrorTitle(title);
          setModalErrorDes(mss);
        });
    } catch (error) {
      setIsLoading(false);
      setIsModalError(true);
    }
  };
  const saveDipchip = async (dipchipData) => {
    setIsLoading(true);
    const complete_date = moment(
      dipchipData.SAfdp_CompleteDate?.date,
      "YYYY-MM-DD HH:mm:ss.SSSSSS",
    );
    const saveData = [
      {
        name: "dipchip_status",
        url: `${Configs.baseAPIURL03}/form/dipchip/manp`,
        postData: {
          head_token: head_token,
          id_card: idc?.idCard,
          ae_code: ic?.AECode,
          firstname: dipchipData.SAfdp_FirstName,
          lastname: dipchipData.SAfdp_LastName,
          middlename: dipchipData.SAfdp_MiddleName,
          birthday: dipchipData.SAfdp_Birthday,
          respose_code: dipchipData.SAfdp_ResposeCode,
          respose_desc: dipchipData.SAfdp_ResposeDesc,
          is_error: dipchipData.SAfdp_IsError,
          complete_date: complete_date.format("YYYY-MM-DD HH:mm:ss.SSS"),
          channel: "OA",
          mkt_remark: dipchipData.SAfdp_MKTRemark,
          doc_ref1: dipchipData.SAfdp_Doc_ref1,
          doc_ref2: dipchipData.SAfdp_Doc_ref2,
        },
      },
    ];
    try {
      await GlobalApi.post(saveData[0].url, saveData[0].postData, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res?.data?.Data?.[0]?.IsSuccess !== 1) {
            let mss =
              "กรุณาติดต่อผู้ดูแลการลงทุนเพื่อทำการยืนยันตัวตน หรือติดต่อ DAOL Contact Center 0 2351 1800 เพื่อสอบถามข้อมูลเพิ่มเติม";
            let title = "ไม่พบข้อมูลการยืนยันตัวตน";
            setIsLoading(false);
            setIsModalError(true);
            setModalErrorTitle(title);
            setModalErrorDes(mss);
          } else {
            storeData("pass_dipchip", true);
            setValueModal({
              imgError: false,
              imgSuccess: true,
              title: statusArr["ACCEPTED"][0],
              btnPrimary: "ถัดไป",
            });
            setIsModal(true);
          }
        })
        .catch((er) => {
          console.log(er);
          setIsLoading(false);
          let title = "เกิดข้อผิดพลาด";
          let mss =
            "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
            getData("api_error")?.message +
            ")";
          setIsModalError(true);
          setModalErrorTitle(title);
          setModalErrorDes(mss);
        });
    } catch (error) {
      setIsLoading(false);
      setIsModalError(true);
    }
  };
  useEffect(() => {
    const passDIPCHIP = getData("pass_dipchip");
    if (passDIPCHIP) {
      saveComeback("CONFIRM");
    }
  }, []);
  const popUps = async (val, statusError, statusSuccess) => {
    // val -> True is primary button : False is secondary button
    console.log(" popUps");
    console.log(val);
    console.log(statusError);
    console.log(statusSuccess);

    if (statusSuccess) {
      await saveComeback("CONFIRM");
    }
  };
  return (
    <>
      <HeaderPage
        title="ยืนยันตัวตนทางดิจิทัล (DIPCHIP)"
        onChangeLang={(e) => setLang(e)}
        clickBack={(e) => (e ? handleBack() : "")}
      />
      <Loading status={isLoading} />
      <DialogCustoms
        // imgModalError={valueModal.imgError}
        open={isModalError}
        isModel={setIsModalError}
        title={modalErrorTitle}
        massage={modalErrorDes}
        massageDes={modalErrorMssDes}
        btnPrimary={"ตกลง"}
      />
      <DialogCustoms
        open={isModal}
        isModel={setIsModal}
        imgModalError={valueModal.imgError}
        imgModalSuccess={valueModal.imgSuccess}
        switchType={(e) => {
          popUps(e, valueModal.imgError, valueModal.imgSuccess);
        }}
        title={valueModal.title}
        massage={valueModal.massage}
        btnPrimary={valueModal.btnPrimary}
        btnSecondary={valueModal.btnSecondary}
      />
      <Grid className="background-bg">
        <Grid className="section-consent">
          <Grid className={isMobile ? "box-content-mb" : "box-content"}>
            <Grid container className="box-content-main" columns={16}>
              {!isMobile && (
                <Grid item xs={7} className="box-left">
                  <BoxLeftContent
                    translations={translations?.[lang]?.verify}
                    clickBack={(e) => handleBack()}
                  />
                </Grid>
              )}
              <Grid
                item
                xs={isMobile ? 16 : 9}
                className={isMobile ? "box-right-mb" : "box-right"}
              >
                <Grid className="content">
                  <Grid
                    className="box-right-content pb-3"
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      px: 2,
                    }}
                  >
                    {!isMobile && (
                      <HeaderRight DIPCHIP title="ยืนยันตัวตนทาง Dip Chip" />
                    )}

                    <ScrollBarComponent
                      content={
                        <Grid id="DIPCHIP-steps" container>
                          <Grid sx={{ py: 3, width: "100%" }}>
                            <Typography
                              className="text-primary"
                              sx={{
                                fontFamily: "DB Heavent Med !important",
                                fontSize: "22px",
                                lineHeight: "26px",
                                textAlign: "center",
                              }}
                            >
                              ขั้นตอนการยืนยันตัวตน
                            </Typography>
                          </Grid>

                          {/* ------- DIPCHIP Step 2 -------  */}
                          <Box
                            id="DIPCHIP-step-1"
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              width: "100%",
                              marginBottom: "20px",
                            }}
                          >
                            <Box
                              id="step-img"
                              sx={{
                                marginRight: "16px",
                                padding: "11px",
                                backgroundColor: "#F7F8FB",
                                borderRadius: "10px",
                                width: "48px",
                                height: "48px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <Avatar
                                alt="DIPCHIP-logo"
                                src={DIPCHIP_ICON}
                                variant="rounded"
                                sx={{ width: 48, height: "auto" }}
                                // sx={{ width: 48, height: 26 }}
                              />
                            </Box>
                            <Box id="step-description">
                              <Box>
                                <Typography
                                  className="font-DBHeavent font-18 text-primary"
                                  sx={{ lineHeight: "22px" }}
                                >
                                  ขั้นตอนที่ 1
                                </Typography>
                              </Box>
                              <Box>
                                <Typography
                                  className="font-DBHeavent font-20 text-black"
                                  sx={{ lineHeight: "24px" }}
                                >
                                  ติดต่อเจ้าหน้าที่แนะนำการลงทุน
                                  และเตรียมบัตรประชาชนของลูกค้า เพื่อดำเนินการ{" "}
                                  <Typography
                                    className="font-DBHeavent font-20"
                                    sx={{
                                      color: "#AA875E",
                                      lineHeight: "24px",
                                    }}
                                    variant="span"
                                  >
                                    “Dip Chip”
                                  </Typography>{" "}
                                </Typography>
                              </Box>
                            </Box>
                          </Box>

                          {/* ------- DIPCHIP Step 2 -------  */}
                          <Box
                            id="DIPCHIP-step-2"
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <Box
                              id="step-img"
                              sx={{
                                marginRight: "16px",
                                padding: "11px",
                                backgroundColor: "#F7F8FB",
                                borderRadius: "10px",
                                display: "flex",
                                alignItems: "center",
                                width: "48px",
                                height: "48px",
                              }}
                            >
                              <Avatar
                                alt="daolife-icon"
                                src={DAOL_ICON}
                                variant="rounded"
                                sx={{ width: 48, height: 12 }}
                              />
                            </Box>
                            <Box id="step-description">
                              <Box>
                                <Typography
                                  className="font-DBHeavent font-18 text-primary"
                                  sx={{ lineHeight: "22px" }}
                                >
                                  ขั้นตอนที่ 2
                                </Typography>
                              </Box>
                              <Box>
                                <Typography
                                  className="font-DBHeavent font-20 text-black"
                                  sx={{ lineHeight: "24px" }}
                                >
                                  หลังจากทำการ{" "}
                                  <Typography
                                    className="font-DBHeavent font-20"
                                    sx={{
                                      color: "#AA875E",
                                      lineHeight: "24px",
                                    }}
                                    variant="span"
                                  >
                                    “Dip Chip”
                                  </Typography>{" "}
                                  สำเร็จแล้ว
                                  ให้ท่านกลับมายังระบบเปิดบัญชีออนไลน์ DAOLSEC
                                  เพื่อดำเนินการเปิดบัญชีในขั้นตอนต่อไปภายใน 30
                                  วัน
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                        </Grid>
                      }
                    />
                    <Grid
                      className="font-DBHeavent font-16 font-weight-bold"
                      style={{ color: "red", marginBottom: "10px" }}
                    >
                      * {translations?.[lang]?.verify?.btn_description}
                    </Grid>
                    <ButtonRight
                      BtnSecondary
                      text={translations?.[lang]?.verify?.next_waiting}
                      onNextPage={handleNext}
                      btnStyle={{
                        transform: "unset",
                        top: "0",
                        height: "47px !important",
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default memo(DipchipWaiting);
